import { html } from '@genesislcap/web-core';
import type { CashProData } from './cash-pro-data';

export const CashProDataTemplate = html<CashProData>`
  <div class="cash-pro-data-container">
    <h1>Cash Pro Data</h1>
    
    <div class="grid-section">
      <h2>Deals</h2>
      <div class="grid-container">
        <rapid-grid-pro>
          <grid-pro-genesis-datasource
            keep-col-defs-on-clear-row-data
            resource-name="ALL_MUNIS_DEALS_VIEW"
          ></grid-pro-genesis-datasource>
        </rapid-grid-pro>
      </div>
    </div>

    <div class="grid-section">
      <h2>Series</h2>
      <div class="grid-container">
        <rapid-grid-pro>
          <grid-pro-genesis-datasource
            keep-col-defs-on-clear-row-data
            resource-name="ALL_SERIES"
          ></grid-pro-genesis-datasource>
        </rapid-grid-pro>
      </div>
    </div>

    <div class="grid-section">
      <h2>Maturities</h2>
      <div class="grid-container">
        <rapid-grid-pro>
          <grid-pro-genesis-datasource
            keep-col-defs-on-clear-row-data
            resource-name="ALL_MATURITIES"
          ></grid-pro-genesis-datasource>
        </rapid-grid-pro>
      </div>
    </div>

    <div class="grid-section">
      <h2>Orders</h2>
      <div class="grid-container">
        <rapid-grid-pro>
          <grid-pro-genesis-datasource
            keep-col-defs-on-clear-row-data
            resource-name="ALL_ORDERS"
          ></grid-pro-genesis-datasource>
        </rapid-grid-pro>
      </div>
    </div>
  </div>
`;
